import type { VideoJsPlayer } from 'video.js';

import videojs from 'video.js';

import { tryToAutoplay } from './try-to-play';

export type VideoJsSource = string | videojs.Tech.SourceObject | videojs.Tech.SourceObject[];

export async function setPlayerSrc(player: VideoJsPlayer, src: VideoJsSource, autoplay: boolean) {
  // pause, to stop source (chunk/playlist) loading and prevent crashes
  if (!player.paused()) {
    player.pause();
  }

  if (player.currentSource()) {
    // clear previous sources to avoid conflicts on mobile
    player.tech(true).reset();
  }

  player.src(src);

  if (autoplay) {
    await tryToAutoplay(player);
  }
}
